import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../utils/baseQueryWithAuth';

export const accessControlApi = createApi({
  reducerPath: 'accessControlApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['SalonAccess', 'Managers'],
  endpoints: (builder) => ({
    mySalonAccess: builder.query<any, void>({
      query: () => '/api/access-control/me/',
      providesTags: ['SalonAccess'],
    }),
    permissionCatalog: builder.query<any, void>({
      query: () => '/api/access-control/permission-catalog/',
    }),
    managers: builder.query<any, void>({
      query: () => '/api/access-control/managers/',
      providesTags: ['Managers'],
    }),
    manager: builder.query<any, number>({
      query: (userId) => `/api/access-control/managers/${userId}/`,
      providesTags: (_result, _error, userId) => [{ type: 'Managers', id: userId }],
    }),
    createManager: builder.mutation<any, Record<string, unknown>>({
      query: (body) => ({ url: '/api/access-control/managers/', method: 'POST', body }),
      invalidatesTags: ['Managers', 'SalonAccess'],
    }),
    updateManager: builder.mutation<any, { userId: number; [key: string]: unknown }>({
      query: ({ userId, ...body }) => ({
        url: `/api/access-control/managers/${userId}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Managers', 'SalonAccess'],
    }),
    removeManager: builder.mutation<void, { userId: number; salon_ids: number[] }>({
      query: ({ userId, salon_ids }) => ({
        url: `/api/access-control/managers/${userId}/`,
        method: 'DELETE',
        body: { salon_ids },
      }),
      invalidatesTags: ['Managers', 'SalonAccess'],
    }),
  }),
});

export const {
  useMySalonAccessQuery,
  usePermissionCatalogQuery,
  useManagersQuery,
  useManagerQuery,
  useCreateManagerMutation,
  useUpdateManagerMutation,
  useRemoveManagerMutation,
} = accessControlApi;
